module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vshou5-08561c2c47dcc7df01761d5b2546490a.jpg";